import { render, staticRenderFns } from "./schoolEdit.vue?vue&type=template&id=0e82186c&scoped=true&"
import script from "./schoolEdit.vue?vue&type=script&lang=js&"
export * from "./schoolEdit.vue?vue&type=script&lang=js&"
import style0 from "./schoolEdit.vue?vue&type=style&index=0&id=0e82186c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82186c",
  null
  
)

export default component.exports